import { Accordion, Box, Text } from "@mantine/core";
import useStyles from "./styles";
import { IconInfoCircle, IconChevronDown } from "@tabler/icons-react";

const EssentialViewInfo = ({ data, className }) => {
  const { classes } = useStyles();

  if (!data) return null;

  const isActivityLevelData =
    Array.isArray(data?.activities) && data.activities.length > 0;

  const selectedActivity = isActivityLevelData
    ? data.activities.find((a) => a.id === data.essentialActivityNumber)
    : null;

  const howOftenValue = selectedActivity && selectedActivity?.howOftenEssentialSupport
    ? selectedActivity.howOftenEssentialSupport
    : data?.howOftenEssentialSupport;

  const activityList = isActivityLevelData
    ? data.activities.filter((a) => a.id === data.essentialActivityNumber)
    : [];

  return (
    <Accordion
      variant="separated"
      radius="lg"
      defaultValue="Apples"
      style={{ marginBottom: "20px" }}
      chevron={<IconChevronDown size={26} color="#000" />}
      chevronPosition="right"
      chevronSize={34}
      className={className ? className : ""}
      styles={{
        chevron: {
          transition: "transform 200ms ease",
          "&[data-active]": { transform: "rotate(180deg)" },
        },
      }}
    >
      <Accordion.Item key={1} value={"Medication Detail"}>
        <Accordion.Control>
          <IconInfoCircle
            color="gray"
            style={{ marginBottom: "-1px" }}
            size={"15px"}
          />
          {` Info: Essential Support Activities`}
        </Accordion.Control>
        <Accordion.Panel>
          <div className={classes.infoAccordion}>
            <div className={classes.accordionRowWrapper}>
              {activityList.map((a, index) => (
                <div
                  key={a.id || index}
                  className={classes.accordionRowSingleLine}
                >
                  <Text
                    className={classes.accordionRowSingleLineText}
                    variant="text"
                    w={30}
                    fw={400}
                  >
                    {index + 1}
                  </Text>
                  <div
                    style={{
                      width: '100%',
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "10px",
                    }}
                  >
                    <div className={classes.accordianSingleLineBox}>
                      <Text variant="text" fw={600}>
                        Support Statement
                      </Text>
                      <Box className={classes.activityContainer}>
                        <Box className={classes.accordionInput}>
                          <p>{a?.supportStatement || "-"}</p>
                        </Box>
                      </Box>
                    </div>

                    <div className={classes.accordianSingleLineBox}>
                      <Text variant="text" fw={600} mt={10}>
                        How to Support
                      </Text>
                      {Array.isArray(a?.howToSupport) ? (
                        a?.howToSupport?.length > 0 ? (
                          a?.howToSupport?.map((h, i) => (
                              <Box className={classes.accordionInput}>
                                <p key={h.id || i}>{h?.text || "-"}</p>
                              </Box>
                          ))
                        ) : (
                            <Box className={classes.accordionInput}>
                              <p>-</p>
                          </Box>
                        )
                      ) : (
                          <Box className={classes.accordionInput}>
                            <p>{a?.howToSupport || "-"}</p>
                        </Box>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className={classes.accordionRow}>
              <Text variant="text" fw={600} mt={15}>
                How Often
              </Text>
              <div className={classes.howOftenClass}>
                <p>{howOftenValue || "-"}</p>
              </div>
            </div>
          </div>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default EssentialViewInfo;
